import {
  ASSIGN_BULK_PATIENTS_FAIL,
  ASSIGN_BULK_PATIENTS_REQUEST,
  ASSIGN_BULK_PATIENTS_SUCCESS,
  EXPORT_BULK_EVIDENCE_FAIL,
  EXPORT_BULK_EVIDENCE_REQUEST,
  EXPORT_BULK_EVIDENCE_SUCCESS,
  GET_ALL_IMPORT_STATS_FAIL,
  GET_ALL_IMPORT_STATS_REQUEST,
  GET_ALL_IMPORT_STATS_SUCCESS,
  GET_EXPORT_STATS_FAIL,
  GET_EXPORT_STATS_REQUEST,
  GET_EXPORT_STATS_SUCCESS,
  GET_IMPORT_HISTORY_FAIL,
  GET_IMPORT_HISTORY_PATIENTS_FAIL,
  GET_IMPORT_HISTORY_PATIENTS_REQUEST,
  GET_IMPORT_HISTORY_PATIENTS_SUCCESS,
  GET_IMPORT_HISTORY_REQUEST,
  GET_IMPORT_HISTORY_SUCCESS,
  GET_IMPORT_PATIENTS_FAIL,
  GET_IMPORT_PATIENTS_REQUEST,
  GET_IMPORT_PATIENTS_SUCCESS,
  GET_STATS_BY_IMPORT_ID_FAIL,
  GET_STATS_BY_IMPORT_ID_REQUEST,
  GET_STATS_BY_IMPORT_ID_SUCCESS,
  IMPORT_PATIENT_FILE_FAIL,
  IMPORT_PATIENT_FILE_REQUEST,
  IMPORT_PATIENT_FILE_SUCCESS,
  IMPORT_STATUS_FAIL,
  IMPORT_STATUS_REQUEST,
  IMPORT_STATUS_SUCCESS,
  RESET_ASSIGN_BULK_PATIENTS,
  RESET_EXPORT_BULK_EVIDENCE,
  RESET_GET_IMPORT_PATIENTS,
  RESET_IMPORT_PATIENT_FILE,
  RESET_IMPORT_STATUS,
  SET_IMPORT_ID,
} from "../../assets/constants/importFileConstants";

//================   GET ALL IMPORT STATS REDUCER ================
export const getAllImportStatsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ALL_IMPORT_STATS_REQUEST:
      return { loading: true };
    case GET_ALL_IMPORT_STATS_SUCCESS:
      return { loading: false, allImportStats: action.payload };
    case GET_ALL_IMPORT_STATS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

//================   GET EXPORT STATS REDUCER ================
export const getExportStatsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_EXPORT_STATS_REQUEST:
      return { loading: true };
    case GET_EXPORT_STATS_SUCCESS:
      return { loading: false, exportStats: action.payload };
    case GET_EXPORT_STATS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

//================   GET IMPORT HISTORY REDUCER ================
export const getImportHistoryReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_IMPORT_HISTORY_REQUEST:
      return { loading: true };
    case GET_IMPORT_HISTORY_SUCCESS:
      return { loading: false, importedHistory: action.payload };
    case GET_IMPORT_HISTORY_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

//================   GET STATS BY IMPORT ID  REDUCER ================
export const getStatsByImportIdReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_STATS_BY_IMPORT_ID_REQUEST:
      return { loading: true };
    case GET_STATS_BY_IMPORT_ID_SUCCESS:
      return { loading: false, importIdStats: action.payload };
    case GET_STATS_BY_IMPORT_ID_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

//================   IMPORT PATIENT FILE REDUCER ================
export const importPatientFileReducer = (state = {}, action) => {
  switch (action.type) {
    case IMPORT_PATIENT_FILE_REQUEST:
      return { loading: true };
    case IMPORT_PATIENT_FILE_SUCCESS:
      return { loading: false, importedPatientFile: action.payload };
    case IMPORT_PATIENT_FILE_FAIL:
      return { loading: false, error: action.payload };
    case RESET_IMPORT_PATIENT_FILE:
      return {};
    default:
      return state;
  }
};

export const setImportIdReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_IMPORT_ID:
      return { ...state, importId: action.payload };
    default:
      return state;
  }
};

//================   GET IMPORT PATIENTS LIST REDUCER ================
export const getImportPatientsListReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_IMPORT_PATIENTS_REQUEST:
      return { loading: true };
    case GET_IMPORT_PATIENTS_SUCCESS:
      return { loading: false, importedPatientsList: action.payload };
    case GET_IMPORT_PATIENTS_FAIL:
      return { loading: false, error: action.payload };
    case RESET_GET_IMPORT_PATIENTS:
      return {};
    default:
      return state;
  }
};

//================   GET IMPORT HISTORY PATIENTS REDUCER ================
export const getImportHistoryPatientsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_IMPORT_HISTORY_PATIENTS_REQUEST:
      return { loading: true };
    case GET_IMPORT_HISTORY_PATIENTS_SUCCESS:
      return { loading: false, importedHistoryPatients: action.payload };
    case GET_IMPORT_HISTORY_PATIENTS_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};

//================  ASSIGN MEMEBRS TO PATIENTS REDUCER ================
export const assignBulkPatientsReducer = (state = {}, action) => {
  switch (action.type) {
    case ASSIGN_BULK_PATIENTS_REQUEST:
      return { loading: true };
    case ASSIGN_BULK_PATIENTS_SUCCESS:
      return { loading: false, assignedBulkMembers: action.payload };
    case ASSIGN_BULK_PATIENTS_FAIL:
      return { loading: false, error: action.payload };
    case RESET_ASSIGN_BULK_PATIENTS:
      return {};
    default:
      return state;
  }
};

//================  IMPORT BULK EVIDENCE REDUCER ================
export const exportBulkEvidenceReducer = (state = {}, action) => {
  switch (action.type) {
    case EXPORT_BULK_EVIDENCE_REQUEST:
      return { loading: true };
    case EXPORT_BULK_EVIDENCE_SUCCESS:
      return { loading: false, exportedBulkEvidence: action.payload };
    case EXPORT_BULK_EVIDENCE_FAIL:
      return { loading: false, error: action.payload };
    case RESET_EXPORT_BULK_EVIDENCE:
      return {};
    default:
      return state;
  }
};

//================  IMPORT STATUS REDUCER ================
export const checkImportStatusReducer = (state = {}, action) => {
  switch (action.type) {
    case IMPORT_STATUS_REQUEST:
      return { loading: true };
    case IMPORT_STATUS_SUCCESS:
      return { loading: false, importStatus: action.payload };
    case IMPORT_STATUS_FAIL:
      return { loading: false, error: action.payload };
    case RESET_IMPORT_STATUS:
      return {};
    default:
      return state;
  }
};
